import { createFileRoute } from "@tanstack/react-router"
import { lazyImportRouteComponent } from "../../../utils/lazyImportRouteComponent"

export const Route = createFileRoute("/app/account/")({
  component: lazyImportRouteComponent(
    () => import("./-components/AccountPage"),
    "AccountPage"
  ),
})
